export enum NoiseFrequencyRating {
    A = 0,
    C = 1,
    Z = 2
}